import quotes from "@/assets/data/quotes.json";
import Avatar from "@/assets/default-avatar.svg";

export function DailyQuote() {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const diff = now.getTime() - start.getTime();
  const dayOfYear = Math.floor(diff / (1000 * 60 * 60 * 24));
  const quote = quotes.quotes[dayOfYear % quotes.quotes.length];

  return (
    <div className="flex items-end gap-2">
      <div className="flex size-[30px] shrink-0 items-center justify-center rounded-full bg-tertiary shadow-[0_2px_8px_rgba(68,48,138,0.3)]">
        <img src={Avatar} alt="VOCA" className="size-[22px] -mt-px" />
      </div>

      <div className="rounded-2xl rounded-bl-[4px] bg-linear-to-br/srgb from-[#f5f3ff] to-[#ede9fe] border border-tertiary/8 px-4 py-3.5 shadow-[0_1px_4px_rgba(0,0,0,0.04)]">
        <p className="text-[13px] font-medium leading-[1.7] text-[#1e1b4b] break-keep tracking-tight">{quote.text}</p>
      </div>
    </div>
  );
}
